// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26ITG","type":"styles_type__2zmN0","choices":"styles_choices__3PbNX"};